import { render, staticRenderFns } from "./TwoForOneHero.vue?vue&type=template&id=3af5b476&scoped=true&"
import script from "./TwoForOneHero.vue?vue&type=script&lang=js&"
export * from "./TwoForOneHero.vue?vue&type=script&lang=js&"
import style0 from "./TwoForOneHero.vue?vue&type=style&index=0&id=3af5b476&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af5b476",
  null
  
)

export default component.exports